
export default {
  name: 'EoLogoCorporate',
  props: {
    /**
     * Style: hex value of color
     */
    color: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      // Used to scope id's to only this svg instance on the page
      id: null,
    }
  },
  mounted () {
    this.id = this._uid
  },
}
